import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-preview',
  templateUrl: 'image-preview.component.html',
  styleUrls: ['image-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewComponent {
  @Input()
  public modalReference: NgbModalRef;

  @Input()
  public imageId: string;

  public closeModal = (): void => {
    this.modalReference.close();
  }

}
